<script lang="ts">
	import { ControlsContainer, ListItem, Stack, Text } from '@Shelly/shelly-design-system/index';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	export let sensors = [];

	$: secondaryPeripherals = sensors?.filter((i) => !i?.drawer_main) || [];

	const dispatch = createEventDispatcher();
</script>

{#if secondaryPeripherals.length}
	<ControlsContainer size="s" class={'mb-s'} color="color-0">
		<svelte:fragment slot="second">
			<Text element="p" class="text-bold mb-s">
				{$format('settings_title_addon_sensors', {
					default: 'Add-on peripherals',
				})}
			</Text>
			<Stack gap="xs">
				{#each secondaryPeripherals as item, i}
					<div
						role="presentation"
						style={item.peripheralType === 'switch' || item.peripheralInputType === 'digital'
							? ''
							: 'cursor: pointer;'}
						on:click={() => {
							dispatch('click', `measurement_${item.sensor.extid}`);
						}}
					>
						<ListItem
							icon={item.icon}
							title={item.sensor.name}
							progress={{
								title: item.value,
							}}
						/>
					</div>
				{/each}
			</Stack>
		</svelte:fragment>
	</ControlsContainer>
{/if}
